/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RxntTokenResponseDto
 */
export interface RxntTokenResponseDto {
    /**
     * RXNT access token for API calls
     * @type {string}
     * @memberof RxntTokenResponseDto
     */
    accessToken: string;
    /**
     * Token expiration time in seconds
     * @type {number}
     * @memberof RxntTokenResponseDto
     */
    expiresIn: number;
    /**
     * Token type
     * @type {string}
     * @memberof RxntTokenResponseDto
     */
    tokenType: string;
}

/**
 * Check if a given object implements the RxntTokenResponseDto interface.
 */
export function instanceOfRxntTokenResponseDto(value: object): value is RxntTokenResponseDto {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined) return false;
    return true;
}

export function RxntTokenResponseDtoFromJSON(json: any): RxntTokenResponseDto {
    return RxntTokenResponseDtoFromJSONTyped(json, false);
}

export function RxntTokenResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RxntTokenResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'expiresIn': json['expiresIn'],
        'tokenType': json['tokenType'],
    };
}

export function RxntTokenResponseDtoToJSON(json: any): RxntTokenResponseDto {
    return RxntTokenResponseDtoToJSONTyped(json, false);
}

export function RxntTokenResponseDtoToJSONTyped(value?: RxntTokenResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
        'expiresIn': value['expiresIn'],
        'tokenType': value['tokenType'],
    };
}

